(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/helpers/marketplace-helpers.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/helpers/marketplace-helpers.js'); "use strict";

(function () {
  svs.maltipset.helpers = {};

  var isMarketplaceToggled = function isMarketplaceToggled() {
    return svs.core.detect.feature('ft-marketplace-maltipset');
  };

  var getMarketplaceAccount = function getMarketplaceAccount() {
    var marketplace = svs.components.marketplace;

    if (marketplace && marketplace.accountSelector) {
      return marketplace.accountSelector.helpers.getCurrentAccount();
    }

    return undefined;
  };

  svs.maltipset.helpers = {
    isMarketplaceToggled: isMarketplaceToggled,
    getMarketplaceAccount: getMarketplaceAccount
  };
})();
 })(window);